import { useHistory } from 'react-router-dom';
import navigation, { navigationParents } from '../functionalities/navigation';

export default function useGoBack() {
  const history = useHistory();
  return () =>
    navigation.getPrevious() ? history.goBack() : history.push(navigationParents.home.url);
}
